const TextTruncate = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
};
const TextCenter = {
  textAlign: "center"
};
const Margin = (sides, size) => {
  const value = size === "auto" ? "auto" : size <= 0 ? "0.25rem" : "".concat(0.25 * size, "rem");
  switch (sides) {
    case "t":
      return {
        marginTop: value
      };
    case "b":
      return {
        marginBottom: value
      };
    case "s":
      return {
        marginLeft: value
      };
    case "e":
      return {
        marginRight: value
      };
    case "x":
      return {
        marginLeft: value,
        marginRight: value
      };
    case "y":
      return {
        marginTop: value,
        marginBottom: value
      };
  }
};
export { Margin, TextCenter, TextTruncate };